// Kimberly's OSA specials-day calculator. Much simpler than Adam's
// schoolSchedule.js — OSA's specials run on a fixed Mon–Fri weekday
// rotation, not a counted A–G cycle, so this is a plain day-of-week
// lookup instead of a school-day count from a start date.
//
// Source: Ms. Gossels (3rd grade, Room 11) confirmed by text 2026-09-22
// after an earlier newsletter had briefly put Village History on the
// wrong day — matches her original "First Day of School" email and the
// Schools DB "Specials Days" field. If this ever needs re-confirming,
// that's the person to ask, not the classroom newsletters (they've been
// the less reliable source twice now).

import { toDateOnly, isWeekend, fmt } from "./dateUtils";
import { isNoSchoolDay, isHalfDayDate } from "./noSchoolDays";
export { loadNoSchoolDays } from "./noSchoolDays";

// Keyed by Date.getDay() (1 = Monday .. 5 = Friday).
const OSA_SPECIALS = {
  1: { name: "Wellness", time: "8:35 AM" },
  2: { name: "LTEs", time: "1:00 PM" },
  3: { name: "LTS", time: "1:40 PM" },
  4: { name: "Village History", time: "8:35 AM" },
  5: { name: "Art", time: "9:35 AM" },
};

/**
 * Returns today's (or a given date's) OSA special, or null fields if it's
 * not a school day. Shape: { isSchoolDay, special: { name, time } | null, halfDay }
 *
 * halfDay is informational only (OSA's half days are all
 * afternoon parent/student conferences or the last-day early release —
 * none of them cancel the morning/midday specials block), so it doesn't
 * change whether `special` is returned, just flags the day as shortened.
 */
function getTodaySpecial(dateStr) {
  const targetDateStr = dateStr || fmt(new Date());

  if (isNoSchoolDay(targetDateStr, "OSA")) {
    return { isSchoolDay: false, special: null, halfDay: false };
  }

  const target = toDateOnly(targetDateStr);
  if (isWeekend(target)) {
    return { isSchoolDay: false, special: null, halfDay: false };
  }

  const special = OSA_SPECIALS[target.getDay()] || null;
  const halfDay = isHalfDayDate(targetDateStr, "OSA");

  return { isSchoolDay: true, special, halfDay };
}

export { getTodaySpecial };
